module.exports = __webpack_public_path__ + "media/components/page-quote/components/quote-info/progress-icon-1-0ba8d20160253e7790f9092aed4ee7db.svg";